module.exports = __webpack_public_path__ + "static/media/12.d61bdc75.gif";